import React from "react";
import { TextField, Box } from "@mui/material";
import { useFormikContext } from "formik";
import CustomSelectInputComponent from "./custom-select";
import { LeftPanelProps } from "../lead-assignment-props";

const LeftPanel: React.FC<LeftPanelProps> = ({viewRule= false}) => {
  const { values, handleChange, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<any>();

  const activeDropdownOptions = [
    { label: "Active", value: "Active", id: 1 },
    { label: "Inactive", value: "Inactive", id: 2 },
  ];

  return (
    <div className="left-panel-body">
      <Box className="form-text-input-component">
        <TextField
          type="text"
          name="ruleName"
          placeholder="Enter Rule Name"
          value={values.ruleName}
          onChange={handleChange}
          onBlur={handleBlur}
          inputProps={{ maxLength: 150 }}
          disabled={viewRule}
        />
        {typeof errors?.ruleName === "string" && (
          <div className="error-message">{errors.ruleName}</div>
        )}
      </Box>
      <div className="active-inactive-wrapper">
        <div className="form-select-input-component">
          <CustomSelectInputComponent
            selectedStatus={values.isActive}
            setSelectedStatus={(val: string) => setFieldValue("isActive", val)}
            viewRule={viewRule}
          />
        </div>
      </div>
    </div>
  );
};

export default LeftPanel;
